/* eslint-disable import/no-cycle */
import React from 'react'

import PropTypes from 'prop-types'
import { Trans, useTranslation } from 'react-i18next'
import { connect } from 'react-redux'

import { changeModalState } from 'actions/modalActions'
import Icon, { IconNames } from 'components/icons'
import Modal from 'components/modal'
import theme from 'components/theme'
import { modal as e2eClasses } from 'constants/e2eClasses'
import { isMobile } from 'helpers/utils'
import { mapMediaType } from 'selectors/mediaType'

import {
  CloseModalWrapper,
  Title,
  Subline,
  ButtonsWrapper,
  Button,
  IconWrapper,
  SublineWrapper,
  Image,
  ImageWrapper,
  ModalLabel,
  SubTitle,
  ContentWrapper,
  ButtonLoader
} from './styled'

const ModalAlert = props => {
  const { t } = useTranslation(props.namespace)

  const {
    buttonWidth,
    changeModalState,
    closePage,
    withCancel,
    sublines,
    closeOnAccept,
    title,
    dismissOnClose,
    mobile,
    confirmAction,
    dismissOnAccept,
    noTranslateSubline,
    noButtons,
    backgroundColor,
    width,
    modalName,
    imageSrc,
    confirmButtonLabel,
    cancelButtonLabel,
    cancelAction,
    modalLabel,
    fullHeight,
    titleModalFullHeight,
    paddingRightTitle,
    textJustify,
    isLoading,
    hyperText
  } = props

  const onConfirmClick = () => {
    changeModalState({ isVisible: false, modalName })
    closeOnAccept && closePage && closePage(true)
  }

  const onDismissOnAccept = () => {
    changeModalState({ isVisible: false, modalName })
  }

  const onCloseClick = () => {
    changeModalState({ isVisible: false, modalName })
    closeOnAccept && !dismissOnClose && closePage(false)
    cancelAction && cancelAction()
  }

  const onCancelClick = () => {
    if (props.onCancelClick) {
      props.onCancelClick()
    } else {
      changeModalState({ isVisible: false, modalName })
      closePage && closePage(false)
    }
    cancelAction && cancelAction()
  }

  const widthProps = width ? { width } : mobile ? { width: '90%' } : { autoWidth: true }

  const fullHeightMobile = fullHeight && mobile

  /* noImage={!imageSrc} workaround to fix paddings for modal alert without image
   ** and align close icon acording to it */

  const modalContent = (
    <CloseModalWrapper noImage={!imageSrc}>
      <ContentWrapper>
        {!fullHeightMobile && (
          <React.Fragment>
            <Title paddingRight={paddingRightTitle}>{t(title || 'label.warning')}</Title>
            <IconWrapper aria-label={t('alt.close')} onClick={onCloseClick} noImage={!imageSrc}>
              <Icon name={IconNames.Close} color={theme.colors.blue} />
            </IconWrapper>
          </React.Fragment>
        )}
        {imageSrc && (
          <ImageWrapper>
            <Image src={imageSrc} />
          </ImageWrapper>
        )}
        {modalLabel && (
          <React.Fragment>
            <SubTitle>{t(mobile ? title : 'label.we-are-sorry')}</SubTitle>
            {/**
             * Workaround with html as modal width needs to be auto but UI design
             * limits it and shrink modal label text.
             */}
            <ModalLabel dangerouslySetInnerHTML={{ __html: t(modalLabel) }} />
          </React.Fragment>
        )}
        {(sublines || noTranslateSubline || hyperText) && (
          <React.Fragment>
            {sublines && (
              <SublineWrapper>
                {(sublines || []).map((subline, index) => (
                  <Subline key={`${subline}${index}`} textJustify={textJustify}>
                    {t(subline)}
                  </Subline>
                ))}
              </SublineWrapper>
            )}
            {noTranslateSubline && (
              <SublineWrapper>
                {(noTranslateSubline || []).map((subline, index) => (
                  <Subline key={`${subline}${index}`}>{subline}</Subline>
                ))}
              </SublineWrapper>
            )}
            {hyperText && (
              <SublineWrapper>
                <Subline>
                  <Trans components={{ b: <b />, u: <u /> }} i18nKey={hyperText} />
                </Subline>
              </SublineWrapper>
            )}
          </React.Fragment>
        )}
        {!noButtons && (
          <ButtonsWrapper withCancel={withCancel}>
            <Button
              disabled={isLoading}
              buttonWidth={buttonWidth}
              confirm
              onClick={
                dismissOnAccept ? onDismissOnAccept : closeOnAccept ? onConfirmClick : confirmAction
              }
              e2eClass={e2eClasses.accept}
            >
              {isLoading && <ButtonLoader />}
              {t(confirmButtonLabel || 'label.accept')}
            </Button>
            {withCancel && (
              <Button onClick={onCancelClick} e2eClass={e2eClasses.close}>
                {t(cancelButtonLabel || 'label.cancel')}
              </Button>
            )}
          </ButtonsWrapper>
        )}
      </ContentWrapper>
    </CloseModalWrapper>
  )

  return (
    <Modal
      name={modalName}
      onClose={onCloseClick}
      {...widthProps}
      backgroundColor={backgroundColor}
      fullHeight={fullHeight}
      titleModalFullHeight={t(titleModalFullHeight)}
    >
      {modalContent}
    </Modal>
  )
}

const mapStateToProps = state => ({
  mobile: isMobile(mapMediaType(state))
})

const mapDispatchToProps = {
  changeModalState
}

ModalAlert.propTypes = {
  modalName: PropTypes.string.isRequired
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalAlert)
